import React, { useState, useRef, useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { Upload, Button, Icon, message } from 'antd'
import { FolderViewOutlined,DeleteOutlined } from '@ant-design/icons';
import cn from 'classnames'
import * as apis from '@/apis'
import styles from './upload.module.scss'
export default function({ onChange, value = [], disabled }) {
  const [loading, setLoading] = useState(false)
  let a = disabled

  const dispatch = useDispatch();
  const customRequest = useCallback(file => {
    if (loading) return false

    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'product-files')
    setLoading(true)

    apis.uploadFile(formData).then(response => {
      const asset = {
        id: Math.random().toString(36).slice(-8),
        name: response.name,
        url: response.url,
        file: response._id,
        type: response.type,
        originalname: response.originalname,
        createdAt: new Date()
      }
      const list = [asset, ...value]
      onChange(list)

    }).then(() => {
      message.success('上传成功')
    }).catch(err => {
      message.error(err.message || '图片上传失败')
    }).finally(() => setLoading(false))

    return false
  }, [loading, value])
  const previewPDF = useCallback(src => () => {
    window.open(src);
    //dispatch(actions.showImageViewDialog({src}));
  });
  const onRemoveHandler = useCallback(id => () => {
    const files = value.filter(item => item.id !== id);
    if (onChange) {
      onChange(files);
    }
  }, [value])

  return (
    <div className={styles.wrap}>
      <Upload 
        className={cn('avatar-uploader')}
        showUploadList={false}
        beforeUpload={customRequest}
        accept=".pdf">
        <Button disabled={disabled}>
          <Icon type={loading ? 'loading' : 'plus'} />
          <span>上传</span>
        </Button>
        <span className={styles.fileFormat}>(仅支持pdf格式)</span>
      </Upload>
      <div className={styles.list}>
        {
          value.map(item => (
            <div key={item.id} className={styles.item}>
             <span>{item.originalname}</span>
             <div className={styles.overlay}>
               {!disabled && (<span className={styles.fileBtn} onClick={onRemoveHandler(item.id)}>
                  <DeleteOutlined style={{color:"#ff0000",fontSize:"20px"}}/>
                </span>)
                }
                <span className={styles.fileBtn} onClick={previewPDF(item.url)}>
                  <FolderViewOutlined style={{color:"#ff0000",fontSize:"20px"}}/>
                </span>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
